import DonutChart, { DonutChartData } from "@/components/visualizations/DonutChart/DonutChart";
import useTranslation from "@/hooks/useTranslation";
import Widget from "@/pages/dashboard/components/Widget/Widget";
import { ProductBy, usePackagingImpactPerType } from "@/pages/dashboard/hooks/useProductImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";

function PackagingProductVsLogistics({
  productId,
  metric,
  by,
}: {
  productId: number;
  metric: ImpactMetric;
  by: ProductBy;
}) {
  const translation = useTranslation();
  const { data, isLoading, isFetching } = usePackagingImpactPerType({
    productId,
    by,
    metric: metric.key,
  });

  const chartData: DonutChartData =
    data && data?.length > 0
      ? data?.map((row) => ({
          label: row.label,
          value: row.impact?.[metric.key] || 0,
        }))
      : [];

  return (
    <Widget
      title={translation["productDrawer"]["packagingProductVsLogistics"]["title"]}
      tooltip={translation["productDrawer"]["packagingProductVsLogistics"]["description"]}
    >
      <DonutChart
        colorPalette="ordinal_green"
        data={chartData}
        format={metric.formatter}
        loading={isLoading || isFetching}
      />
    </Widget>
  );
}

export default PackagingProductVsLogistics;
